
























































# import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import m from '@/graphql/mutation'
import q from '@/graphql/query'

export default {
    name: 'company_establishments_edition'
    props:
        uid: {
            type: String
            required: false
            default: ""
        }

    data: ()->
        errors: {}
        establishment: {
            uid: ''
            company_uid: ''
            name: ''
            siret: ''
            address: ''
            address2: ''
            zipcode: ''
            city: ''
            phone: ''
            email: ''
        }

    computed:
        readonly: ()->
            return !t.has_access_right('establishments_edit')

    methods:
        telephone_change: ()->
            @establishment.phone = t.phone_format(@establishment.phone)
            return

        get_establishment: (establishment_uid)->
            self = @
            q.run('get_establishment', [establishment_uid])
            .then (resp)->
                # console.log "GET ONE ESTABLISHMENT : ", resp.body.errors
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_establishments_edition: get_establishment: then", e.message)
                else
                    self.establishment = resp.body.data.establishment
            .catch (resp)->
                n.catch_error(resp, "company_establishments_edition: get_establishment()")

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        save: ()->
            # console.log "ETAB EDITION SAVE"
            self = @
            @establishment.company_uid = @$store.getters.current_company.uid
            m.run('save_establishment', [@establishment])
            .then (resp)->
                if resp.body.data.establishment_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.establishment_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.establishment_form_mutation.errors
                    self.errors = resp.body.data.establishment_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    n.success()
                    if self.establishment.uid == ""
                        self.$router.push({name:'company_establishments_edition', params:{uid:resp.body.data.establishment_form_mutation.form_ret}})
                        self.establishment.uid = resp.body.data.establishment_form_mutation.form_ret
                        self.get_establishment(resp.body.data.establishment_form_mutation.form_ret)
            .catch (resp)->
                n.catch_error(resp, "company_establishments_edition: save()")

    beforeMount: ()->
        if @uid != "0"
            @get_establishment(@uid)
        # console.log "ESTABLISHMENTS EDITION", @uid, @establishment
}

